module.exports = __webpack_public_path__ + "img/stats icon.b245d317.svg";